import React, { Component } from 'react';
import {connect} from 'react-redux';
import {hideModal} from '../../../actions/modal.actions';
import {getPrimaryContacts} from "../../../actions/admin.actions";
import {sendRegistrationLink, updateUserAccess} from "../../../actions/accountDetailsActions/security.actions";
import {
    createLoadingSelector,
    getAccountDetails,
    getAdmin,
    getModalData,
    getUser,
    getUserPermission,
    getAuthData,

} from '../../../selectors';
import {Formik} from "formik";
import ContactInput from "../../AccountDetails/Panels/RightPanel/Tabs/Security/Inputs/ContactInput";
import {toastr} from "react-redux-toastr";
import isEmpty, {getRefreshToken, getToken} from "../../../utils/helpers";
import Loader from "../../../components/Loader";
import { groupStyles } from "src/utils/SelectStyles";
import Select from "react-select";
import Button from "src/components/Common/Buttons/Button";
import { getAccounts } from "src/actions/account-search";
import moment from "moment/moment";
import { getSystemUsersUi } from 'src/actions/uiController.actions';
import { getLinkedAccounts, getLinkedAccountsUserId, linkAccount, unLinkAccount, } from 'src/actions/linkedAccounts.actions'
import AsyncSelect from 'react-select/async';
import { forgottenCustomerPassword } from "src/actions/auth.actions";
import { accountsSearchByUserName } from "src/actions/account-search";


class CustomerPortalModal extends Component {

    state = {
        id: this.props.modalProps.primaryContact.userAccess ? this.props.modalProps.primaryContact.userAccess.id : 99999999,
        userAccess: null,
        errors: [],
        allAccountsToggled: true,
        accountIds: [],
        accountNumber: null,
        immediateAutoPayToggled: true,
        linkedAccounts: [],
        linkedUsers: [],
        linkAccountPayload: {
            "accountId": null,
            "requestedBySystemUserId": null,
            "userId": null
        },
        tableRequest: {
            "filterList": [
                {
                    columnName: "email",
                    value: null
                }
            ],
            pagination: {
                limit: 20,
                offset: 0
            },
            sorting: {
                columnName: "su.id",
                sortParam: "asc"
            }
        },
        accountNumberSelectedId: null,
        emailInput: null,
        istLoading: false,
        collapsible: {
            userAccess: false,
            linkedAccts: false,
            linkAcc: false,
        },
        hoverStates: {},
        iconHoverStates: {},
        divHover: false,
        accountNumberOptions: [],
    }




    componentDidMount() {
        const {modalProps} = this.props;

        this.props.getLinkedAccountsUserId(this.state.id).then(response => {

            if (response && response.linkedAccountList && Array.isArray(response.linkedAccountList)) {
                this.setState({ linkedUsers: response.linkedAccountList });
            } else {
                this.setState({ linkedUsers: [] });
            }
        });

        this.props.getLinkedAccounts(this.props.accountId).then(response => {
            if (response && response.linkedAccountList && Array.isArray(response.linkedAccountList)) {
                this.setState({ linkedAccounts: response.linkedAccountList });
            } else {
                this.setState({ linkedAccounts: [] });
            }
        });

        this.props.getPrimaryContacts(this.props.accountId).then(response => {

            if (response && response.data && response.data.contacts && response.data.contacts[0]) {

                if (!isEmpty(response.data.contacts[0].userAccess)) {
                    this.setState({userAccess: response.data.contacts[0].userAccess})
                }
                else {
                    this.props.showModal('SEND_REGISTRATION_LINK_MODAL', {
                        sendRegistrationLink: this.props.sendRegistrationLink,
                        linkedAccounts: this.state.linkedAccounts

                    })
                }
            }
        });

        if(modalProps.value) {
            this.props.getAutoPayJob(modalProps.value).then((response) => {
                if (response.accounts.length) {
                    let selectedAccounts = response.accounts.map((account) =>
                      account =  {label: account.number + ' - ' + account.name,
                          value: account.id}
                    )
                    this.setState({allAccountsToggled: false, accountIds: selectedAccounts})
                }

                this.setState({
                    autoPayJobsLoader: true,
                    autoPayJob: response,
                    selectedDate: moment(response.scheduledDateString).local().toDate()
                })
            })
        }else{
            this.setState({
                autoPayJobsLoader: true,
                autoPayJob: null
            })
        }
    }

    handleCloseInput = () => {
        this.setState({
            isEditable: '',
            errors: {},
        });
    };

    handleEditField = (fieldName) => {
        let updatedErrors = this.state.errors;
        updatedErrors[fieldName] = "";

        this.setState({
            isEditable: fieldName,
            errors: updatedErrors,
        });
    };

    handleUpdateUserAccess = (e) => {
        let data = {
            active: e.target.checked
        };

        this.props.updateUserAccess(this.state.id, data).then((response) => {
            if (response.success) {
                toastr.success(response.message, { timeOut: 2000, position: 'top-center' });
                this.closeModal();
            }
            else {
                toastr.error("Failed to update user access", { timeOut: 2000, position: 'top-center' });
            }
        })
    };

    handleImpersonateUser = () => {
        const customerPortalBaseUrl = !isEmpty(this.props.customerPortalBaseUrl) ? this.props.customerPortalBaseUrl.value : '';
        const userId = this.state.id;
        const apiToken = encodeURIComponent(getToken());

        const newWindow = window.open(`${customerPortalBaseUrl}/impersonate/${userId}?apiToken=${apiToken}`, '_blank');

        if (newWindow) newWindow.opener = null;
    }

    closeModal = () => {
        if (this.props.modalProps.onCloseCallback) {
            this.props.modalProps.onCloseCallback();
        }
        this.props.hideModal();
    };

    toggleCollapse = (group) => {
        this.setState(prevState => ({
            grouped: {
                ...prevState.grouped,
                [group]: !prevState.grouped[group]
            }
        }));
    }

    loadAccountInfo = (values, setFieldValue) => (value, option) => {
        if (option && option.action === 'input-change') {
            setFieldValue('selectedAccountsInput', value);


            if (this['timeout']) {
                clearTimeout(this['timeout']);
            }

            this['timeout'] = setTimeout(() => {
                this.props.getAccounts('ACCOUNT NUMBER', value).then(response => {
                    if (response && response.length > 0) {
                        let updatedSelectedAccountsOptions = [];

                        response.map(user => {
                            updatedSelectedAccountsOptions.push({
                                label: user.number + ' - ' + (user.systemUser ? user.systemUser.firstName + ' ' + user.systemUser.lastName : user.name),
                                value: user.id
                            });
                        });

                        this.setState({ selectedAccountsOptions: updatedSelectedAccountsOptions });
                    }
                });
            }, 1000);
        }
    }

    handleInput = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleResetPassword = () => {

        toastr.confirm('Are you sure you want to Reset Password for this user?', {
            cancelText: 'Cancel',
            okText: 'Confirm',
            onOk: () => {
                this.props.forgottenCustomerPassword(this.props.modalProps.primaryContact.emails[0].email).then((response) => {
                    if (response.success) {
                        toastr.success('Password Reset link Sent Successfully')
                    }
                });
            }
        })

    };

    handleSubmit = async () => {

        toastr.confirm(this.handleLinkConfirmationMessage(this.state.accountNumberSelectedId), {
            cancelText: "Cancel",
            okText: "Confirm",
            onOk: () => {
                const linkAccountPayload = {
                    "accountId": this.state.accountNumberSelectedId,
                    "requestedBySystemUserId": this.props.currentUser.id,
                    "userId": this.state.id,
                };
                this.props.linkAccount(linkAccountPayload, this.state.linkedUsers)
                  .then((response) => {
                      if (response && response.message === 'User already exists') {
                          toastr.error(response.message, {timeOut: 2000, position: 'top-center'});
                      } else {
                          toastr.success('Account Linked Successfully!', {timeOut: 2000, position: 'top-center'})
                      }
                      this.refreshLinkedAccountsAndUsers();
                  })
                  .catch(error => {
                      if (error && error.message) {
                          toastr.error(error.message, {timeOut: 2000, position: 'top-center'});
                      } else {
                          toastr.error("An error occurred", {timeOut: 2000, position: 'top-center'});
                      }
                  });
            },
            onCancel: () => {
            }
        });
    }



    addAccountNumber = (values, setFieldValue) => (option, action) => {
        if (action.action === 'select-option' && action.option) {
            setFieldValue("selectedAccountsInput", '');
            setFieldValue(
              "accountIds",
              [...values.accountIds, action.option]
            );
        }

        if (action.action === 'remove-value' && action.removedValue) {
            setFieldValue(
              "accountIds",
              [...values.accountIds.filter(optionValue => optionValue.value !== action.removedValue.value)]
            );
        }
    }



    handleUnlink = (userId, accountId) => {
        const unLinkAccountPayload = {
            "accountId": accountId,
            "unregisteredBySystemUserId": this.props.currentUser.id,
            "userId": userId
        };
        this.props.unLinkAccount(unLinkAccountPayload)
          .then(() => {
              toastr.success('Account Unlinked Successfully!', {timeOut: 2000, position: 'top-center'});
              this.refreshLinkedAccountsAndUsers();
          })
          .catch(error => {
              toastr.error(error, {timeOut: 2000, position: 'top-center'});
          });
    }

    handleAction = (type, userId, accountId, accountObj) => {

        console.log(accountObj)

        if (type === 'unlinkAccount'){

            toastr.confirm(this.handleUnLinkConfirmationMessage(accountObj), {
                cancelText: "Cancel",
                okText: "Confirm",
                onOk: () => {
                    this.handleUnlink(userId, accountId);
                },
                onCancel: () => {
                }
            });

        } else if (type === 'unlinkUser') {
            let obj  ={
                accountNumber: accountObj.systemUserContactAccountNumbers[0],
                companyName: accountObj.systemUserContactName

            }
            toastr.confirm(this.handleUnLinkConfirmationMessage(obj), {
                cancelText: "Cancel",
                okText: "Confirm",
                onOk: () => {
                    this.handleUnlink(userId, accountId);
                },
                onCancel: () => {
                }
            });
        }

    }

    refreshLinkedAccountsAndUsers = () => {
        this.setState({ isLoading: true });

        this.props.getLinkedAccountsUserId(this.state.id).then(response => {
            if (response && Array.isArray(response.linkedAccountList)) {
                this.setState({ linkedUsers: response.linkedAccountList }, () => {
                    this.props.getLinkedAccounts(this.props.accountId).then(response => {
                        if (response && Array.isArray(response.linkedAccountList)) {
                            this.setState({ linkedAccounts: response.linkedAccountList });
                        } else {
                            this.setState({ linkedAccounts: [] });
                        }

                        this.setState({ isLoading: false });
                    });
                });
            } else {
                this.setState({ linkedUsers: [] });

                this.setState({ isLoading: false });
            }
        });
    }

    toggleHover = () => {
        this.setState(prevState => ({ hover: !prevState.hover }));
    }

    handleAccountNumberChange = (selectedOption) => {

        if (selectedOption === null) {
            this.setState({ accountNumberSelectedId: null, accountNumber: null });
        } else {
            this.setState({ accountNumberSelectedId: selectedOption.value, accountNumber: selectedOption.number });
        }
    }


    loadOptions = (inputValue) => {
        return new Promise(resolve => {
            this.props.getAccounts('ACCOUNT NUMBER', inputValue)
              .then(response => {
                  if (response && response.length > 0) {
                      let options = response.map(account => ({
                          value: account.id,
                          label: `${account.number} - ${account.name}`,
                          number: account.number
                      }));
                      resolve(options);
                  } else {
                      resolve([]);
                  }
              });
        });
    }


    handleLinkConfirmationMessage = () => {
        if(this.props.primaryContacts && this.props.primaryContacts[0].company) {
            return `Are you sure you want to link user ${this.props.primaryContacts[0].company} to account# ${this.state.accountNumber}`
        } else {
            return `Are you sure you want to link user ${this.props.primaryContacts[0].firstName} ${this.props.primaryContacts[0].lastName} to account# ${this.state.accountNumber}`
        }
    }

    handleUnLinkConfirmationMessage = (accountObj) => {

        if(accountObj && accountObj.companyName === null || accountObj.companyName === '' ) {
            return `You are about to unlink ${accountObj.contactName} account, account # ${accountObj.accountNumber}`
        } else  {
            return `You are about to unlink ${accountObj.companyName} account, account # ${accountObj.accountNumber
            }`
        }
    }


    render() {


        const option = [
            { label: this.props.modalProps.primaryContact.emails[0].email, value: this.props.modalProps.primaryContact.emails[0].email, placeholder: this.props.modalProps.primaryContact.emails[0].email },
        ];

        const {
            id,
            userAccess,
        } = this.state;

        const {
            userAccessUpdating,
            primaryContactsLoading,
            primaryContacts,
            canImpersonate,
            customerPortalBaseUrl,


        } = this.props;

        const styles = {
            normal: { color: '#7a8288' },
            hover: { color: '#bf433d',
                cursor: 'pointer'}
        };

        const divStyles =
          {

              borderTop: '1px solid #e5e5e5',
              paddingTop: '10px'
          }

        const topIconStyles = {
            normal: { color: '#7a8288' },
            hover: { color: '#6ab3c2', cursor: 'pointer' }
        };






        return (
          <>
              <div className="modal" style={{display: 'block', }} tabIndex="-1" role="dialog">
                  <div className="modal-dialog">
                      <div className="modal-content" >

                          <div className="modal-header">
                              <h5 className="modal-title">Customer Portal Access</h5>
                              <button onClick={this.closeModal} type="button" className="close">
                                  <span aria-hidden="true">&times;</span>
                              </button>
                          </div>

                          <div className="modal-body p-4" >

                              {primaryContactsLoading
                                ?
                                <Loader />
                                :
                                isEmpty(userAccess)
                                  ?
                                  (

                                    <span className="form-header-toolbar">
                                    <button
                                      type="button"
                                      className="btn btn-xs btn-outline-secondary btn-cn-edit"
                                      onClick={() => this.props.showModal('SEND_REGISTRATION_LINK_MODAL', {
                                          sendRegistrationLink: this.props.sendRegistrationLink,
                                          UserId: 'test'
                                      })}
                                    >
                                        Send Link
                                    </button>
                                    </span>





                                  )


                                  :
                                  <div className="form-subsection">

                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="w-50">

                                              <div style={{
                                                  position: "relative",
                                                  height: "40px",
                                                  overflow: "visible"
                                              }}><Select
                                                id="searchType"
                                                name="searchType"
                                                value="user"
                                                options={option}
                                                placeholder={this.props.modalProps.primaryContact.emails[0].email}
                                                styles={groupStyles}


                                              /></div>


                                              <div
                                                className="text-muted text-sm">{this.props.modalProps.primaryContact.emails[0].email}</div>
                                          </div>
                                          <div>
                                              <div className="d-flex justify-content-between align-items-center">
                                                  <div className="px-2">
                                                      <i className="fa fa-undo "
                                                         onMouseEnter={() => this.setState(prevState => ({
                                                             iconHoverStates: {
                                                                 ...prevState.iconHoverStates,
                                                                 undo: true
                                                             }
                                                         }))}
                                                         onMouseLeave={() => this.setState(prevState => ({
                                                             iconHoverStates: {
                                                                 ...prevState.iconHoverStates,
                                                                 undo: false
                                                             }
                                                         }))}
                                                         onClick={this.handleResetPassword}
                                                         style={this.state.iconHoverStates.undo ? topIconStyles.hover : topIconStyles.normal} />
                                                  </div>
                                                  <div className="px-2">
                                                      {canImpersonate && !isEmpty(id) && !isEmpty(customerPortalBaseUrl) &&
                                                        <i className="fa fa-user-secret "
                                                           data-toggle="tooltip" data-placement="top"
                                                           title="Impersonate"
                                                           onMouseEnter={() => this.setState(prevState => ({
                                                               iconHoverStates: {
                                                                   ...prevState.iconHoverStates,
                                                                   impersonate: true
                                                               }
                                                           }))}
                                                           onMouseLeave={() => this.setState(prevState => ({
                                                               iconHoverStates: {
                                                                   ...prevState.iconHoverStates,
                                                                   impersonate: false
                                                               }
                                                           }))}
                                                           style={this.state.iconHoverStates.impersonate ? topIconStyles.hover : topIconStyles.normal}
                                                           onClick={() => this.handleImpersonateUser()} />
                                                      }

                                                  </div>

                                                  <div className="d-flex justify-content-between align-items-center">
                                                      <span className="px-2">Active</span>
                                                      <div
                                                        className="form-check checkbox-slider checkbox-slider--b-flat">
                                                          <label className="w-100 m-0">
                                                              <input
                                                                id="enable-portal-access"
                                                                type="checkbox"
                                                                defaultChecked={userAccess.isActive}
                                                                onClick={(e) => this.handleUpdateUserAccess(e)}
                                                                disabled={userAccessUpdating}
                                                              />
                                                              <span className="text-right">{""}</span>

                                                          </label>
                                                      </div>

                                                  </div>


                                              </div>


                                          </div>


                                      </div>


                                      <hr />


                                      <div className="d-flex flex-column"
                                           style={{ maxHeight: "600px", overflowY: "auto", overflowX: "hidden" }}>


                                          <div className="form-group row mt-3">

                                              <div className="col-12 col-sm-7" style={{
                                                  position: "relative",
                                                  height: "100px",
                                                  overflow: "visible",

                                              }}>

                                                  <AsyncSelect
                                                    placeholder="Account Number"
                                                    cacheOptions
                                                    clearAll
                                                    defaultOptions
                                                    loadOptions={this.loadOptions}
                                                    onChange={this.handleAccountNumberChange}
                                                    styles={groupStyles}
                                                    isClearable={true}
                                                  />

                                              </div>

                                              <div className="col-12 col-sm-5 mt-3 mt-sm-0">
                                                  <Button
                                                    type="button"
                                                    onClick={this.handleSubmit}
                                                    className="btn btn-primary btn-show-cam-search-results w-100"
                                                    style={{ height: "37px" }}
                                                    disabled={this.state.accountNumberSelectedId === null}
                                                  >
                                                      <i className="fa fa-link " style={styles.iconHover} />
                                                      <span>&nbsp;Link Account</span>
                                                  </Button>
                                              </div>
                                          </div>


                                          {this.state.linkedUsers.length > 0 ?
                                            (
                                              <>
                                                  <div className="text-muted text-sm mt-3" style={divStyles}>
                                                      This user has access to the following accounts. They can view
                                                      invoices,
                                                      Pay bills and sign up for AutoPay
                                                  </div>
                                                  <div className="cmv-container-table mt-3">

                                                      {this.state.isLoading ? <Loader /> : (
                                                        <table
                                                          className="table cmv-table cmv-table-mobile cmv-table-solid">
                                                            <thead>
                                                            <tr>
                                                                <th>
                                                                    Customer
                                                                </th>
                                                                <th>
                                                                    Account Status
                                                                </th>
                                                                <th className="text-center">
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {this.state.linkedUsers.map((user, index) => (
                                                              <tr key={index + 100}>
                                                                  <td>
                                                                      <div>{user.accountInfo.accountType === "Business" && user.accountInfo.companyName !== "" ? user.accountInfo.companyName : user.accountInfo.contactName}</div>
                                                                      {user.accountInfo && user.accountInfo.primaryContactEmails[0]
                                                                        ? <div
                                                                          className="text-sm text-muted">{user.accountInfo.primaryContactEmails[0].email}</div>
                                                                        : <div
                                                                          className="text-sm text-muted">-</div>}
                                                                  </td>
                                                                  <td>
                                                                      <div
                                                                        className={user.accountInfo.accountStatus === "Active" ? "text-success" : user.accountInfo.accountStatus === "Deactivated" ? "text-danger" : "text-warning"}>{user.accountInfo.accountStatus}</div>
                                                                      <div
                                                                        className="text-sm text-muted">{user.accountInfo.accountNumber}</div>
                                                                  </td>
                                                                  <td className="tr-actions text-center">
                                                                      <i
                                                                        onClick={() => this.handleAction("unlinkAccount", user.systemUserId, user.accountInfo.accountId, user.accountInfo)}
                                                                        className="fa fa-ban"
                                                                        onMouseEnter={() => this.setState(prevState => ({
                                                                            hoverStates: {
                                                                                ...prevState.hoverStates,
                                                                                [index + 100]: true
                                                                            }
                                                                        }))}
                                                                        onMouseLeave={() => this.setState(prevState => ({
                                                                            hoverStates: {
                                                                                ...prevState.hoverStates,
                                                                                [index + 100]: false
                                                                            }
                                                                        }))}
                                                                        style={this.state.hoverStates[index + 100] ? styles.hover : styles.normal}
                                                                        aria-hidden="true"></i>
                                                                  </td>
                                                              </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                      )}


                                                  </div>
                                              </>
                                            ) : null}

                                          {this.state.linkedAccounts.length > 0 && !this.state.linkedAccounts.registeredDatetime
                                            ?
                                            (
                                              <>
                                                  <div className="text-muted text-sm mt-2" style={divStyles}>
                                                      Following users have access to this account. They can view
                                                      invoices, pay
                                                      bills, and signup for AutoPay.
                                                  </div>
                                                  <div className="cmv-container-table mt-3">
                                                      {this.state.isLoading ? <Loader /> : (
                                                        <table
                                                          className="table cmv-table cmv-table-mobile cmv-table-solid">
                                                            <thead>
                                                            <tr>
                                                                <th>
                                                                    Users
                                                                </th>
                                                                <th>
                                                                    Account Status
                                                                </th>
                                                                <th className="text-center">
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {this.state.linkedAccounts.map((account, index) => (
                                                              <tr key={index}>
                                                                  <td>
                                                                      <div>{account.systemUserContactName}</div>

                                                                      {account.systemUserContactEmails && account.systemUserContactEmails[0]
                                                                        ? <div
                                                                          className="text-sm text-muted">{account.systemUserContactEmails[0].email}</div>
                                                                        : <div
                                                                          className="text-sm text-muted">-</div>
                                                                      }


                                                                  </td>
                                                                  <td>
                                                                      <div
                                                                        className={account.accountInfo.accountStatus === "Active" ? "text-success" : account.accountInfo.accountStatus === "Inactive" ? "text-danger" : "text-warning"}>{account.accountInfo.accountStatus}</div>
                                                                      <div
                                                                        className={`text-sm text-muted `}>{account.systemUserContactAccountNumbers[0]}</div>
                                                                  </td>
                                                                  <td className="tr-actions text-center">
                                                                      <i
                                                                        onClick={() => this.handleAction("unlinkUser", account.systemUserId, account.accountInfo.accountId, account)}
                                                                        className="fa fa-ban"
                                                                        onMouseEnter={() => this.setState(prevState => ({
                                                                            hoverStates: {
                                                                                ...prevState.hoverStates,
                                                                                [index]: true
                                                                            }
                                                                        }))}
                                                                        onMouseLeave={() => this.setState(prevState => ({
                                                                            hoverStates: {
                                                                                ...prevState.hoverStates,
                                                                                [index]: false
                                                                            }
                                                                        }))}
                                                                        style={this.state.hoverStates[index] ? styles.hover : styles.normal}
                                                                        aria-hidden="true"></i>
                                                                  </td>
                                                              </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                      )}

                                                  </div>
                                              </>
                                            ) : null}


                                      </div>


                                      {userAccess.invalidLoginAttempts < 0 &&
                                        <div className="form-row mb-1">
                                            <div className="col-sm-5 col-xl-4">
                                                Failed Logins
                                            </div>
                                            <div className="col-sm-7 col-xl-8">
                                                <label>
                                                <span className={userAccess.invalidLoginAttempts >= 5
                                                  ? "text-danger font-weight-bold"
                                                  : ""}
                                                >
                                                    {userAccess.invalidLoginAttempts} / 5
                                                </span>
                                                </label>
                                            </div>
                                        </div>
                                      }

                                  </div>
                              }

                          </div>

                          <div className="modal-footer">
                              <button onClick={this.closeModal} className="btn" type="button">
                                  Close
                              </button>
                          </div>

                      </div>
                  </div>
              </div>
              <div className="modal-backdrop show" tabIndex="1" />
          </>
        );
    }
}

const userAccessLoader = createLoadingSelector(["UPDATE_USER_ACCESS"]);
const primaryContactsLoader = createLoadingSelector(["GET_PRIMARY_CONTACT"]);
const accountLoader = createLoadingSelector(["ACCOUNT_SEARCH"]);

const mapStateToProps = (state) => {

    const modalProps = getModalData(state).modalProps;
    const accountId = getAccountDetails(state).accountDetails.accountInfo.id;
    const primaryAccountNumber = getAccountDetails(state).accountDetails.accountInfo.number
    const userAccessUpdating = userAccessLoader(state);
    const primaryContactsLoading = primaryContactsLoader(state);
    const primaryContacts = getAdmin(state).primaryContacts;
    const canImpersonate = getUserPermission(state, 'BILLING', 'BILLING_IMPERSONATE_CUSTOMER');
    const customerPortalBaseUrl = getUser(state).configuration.find((x) => x.key === 'portal.baseUrl') || '';
    const accountLoading = accountLoader(state)
    const userAccount = getAuthData(state)
    const currentUser = getUser(state).user;


    return {
        modalProps,
        accountId,
        userAccessUpdating,
        primaryContactsLoading,
        primaryContacts,
        canImpersonate,
        customerPortalBaseUrl,
        accountLoading,
        userAccount,
        currentUser,
        primaryAccountNumber

    };
};

const mapDispatchToProps = {
    hideModal,
    getPrimaryContacts,
    updateUserAccess,
    sendRegistrationLink,
    getAccounts,
    getLinkedAccounts,
    getLinkedAccountsUserId,
    getSystemUsersUi,
    linkAccount,
    unLinkAccount,
    forgottenCustomerPassword
};

//http://localhost:3001/impersonate/286?apiToken=NukKR2M70UdXdEXOOaxrYSdMstgiLlBkNLCmCHeaWiU%3D

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPortalModal)

